import { createSlice } from '@reduxjs/toolkit'
import { signOut } from 'store/auth'
import { FirestoreDatabase } from 'index'
import { Collection } from 'constants/index'
import { getDatesInRange } from 'utils'
import moment from 'moment-timezone'
import { orderBy } from 'lodash'

export const initialState = {
  error: null,
  inProgress: false,
  attendeesAttendance: [],
  confFilter: '',
  currentPage: 0,
  pageSize: 10
}

const attendanceSlice = createSlice({
  name: 'attendance',
  initialState: initialState,
  reducers: {
    setError: (state, action) => {
      state.error = action.payload
    },
    setProgress: (state, action) => {
      state.inProgress = action.payload
    },
    setConferenceFilter: (state, action) => {
      state.confFilter = action.payload
    },
    setAttendeesAttendance: (state, action) => {
      state.attendeesAttendance = action.payload
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload
    },
    setAttendee: (state, action) => {
      state.attendee = action.payload
    }
  },
  extraReducers: {
    [signOut.fulfilled]: (state) => {
      state.error = null
      state.inProgress = false
      state.attendeesAttendance = []
      state.confFilter = ''
      state.currentPage = 0
      state.pageSize = 10
    }
  }
})

export const fetchAttendeesAttendance = (conferenceId) => async (dispatch) => {
  try {
    dispatch(attendanceSlice.actions.setProgress(true))

    const attendeesSnap = await FirestoreDatabase.collection(Collection.ATTENDEES)
      .where('conferenceId', '==', conferenceId)
      .get()

    const attendees = attendeesSnap.docs?.map((doc) => ({
      id: doc.id,
      ...doc.data()
    }))

    const attendeesAttendanceSnap = await FirestoreDatabase.collection(Collection.ATTENDANCE)
      .where('conferenceId', '==', conferenceId)
      .get()

    const attendeesAttendance =
      attendeesAttendanceSnap.docs?.map((doc) => ({
        id: doc?.id,
        ...doc?.data()
      })) || []

    const confSnap = await FirestoreDatabase.collection(Collection.CONFERENCES)
      .doc(conferenceId)
      .get()

    const conference = { id: confSnap.id, ...confSnap.data() }
    const confDates = getDatesInRange(
      moment(conference?.startDate).tz(conference?.timezone).format('MM/DD/YYYY'),
      moment(conference?.endDate).tz(conference?.timezone).format('MM/DD/YYYY')
    )

    const attendeesWithAttendance = attendees.map((attendee) => {
      const attendeeAttendance = confDates.map((date) => {
        const attendanceFound = attendeesAttendance?.some((attendance) => {
          return attendance.attendeeId === attendee.id && attendance.attendanceDate === date
        })
        return { date: date, attendanceFound: attendanceFound }
      })

      return { ...attendee, attendance: orderBy(attendeeAttendance, 'date', 'asc') }
    })
    dispatch(attendanceSlice.actions.setAttendeesAttendance(attendeesWithAttendance))
    dispatch(attendanceSlice.actions.setProgress(false))
  } catch (err) {
    dispatch(attendanceSlice.actions.setProgress(false))
    dispatch(attendanceSlice.actions.setError(err))
  }
}

export default attendanceSlice
